import React from 'react'
import { flowRight } from 'lodash'
import { withRouter } from 'react-router-dom'
import { Trans, useTranslation } from 'react-i18next'
import ErrorMessageContent from './ErrorMessageContent'
import { getBosPath } from 'lib/utils/store/bos'

const ErrorMessageWithLinkToBos = ({ appError, match, children }) => {
    const { t, i18n } = useTranslation(['errors', 'common'])

    const { type, code } = appError
    const title = t(`errors:${type}.${code}.title`, t('errors:errorMessage.default.title'))
    const message = (
        <Trans i18nKey={`errors:${type}.${code}.message`}>
            Return BoS back to edit mode, check entered values and try again. If this does not fix the problem, contact our customer service. It is also possible to do BoS without online payment. <a href={getBosPath(parseInt(match.params.bosId, i18n.language))}>Return to BoS view.</a>
        </Trans>
    )

    return (
        <ErrorMessageContent
            title={title}
            content={message}
        />
    )
}

export default flowRight(
    withRouter,
)(ErrorMessageWithLinkToBos)
